import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { SelectCentreRoutingModule } from './select-centre.routing';
import { SelectCentreComponent } from './select-centre.component';

@NgModule({
  declarations: [
    SelectCentreComponent
  ],
  imports: [
    SelectCentreRoutingModule,
    SharedModule
  ],
  entryComponents: [
  ],
  providers: [],
  bootstrap: []
})
export class SelectCentreModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/select-centre/select-centre.module.ts